{
  "title": "Opret event fra skabelon",
  "description": "Tilpas event-detaljer før oprettelse",
  "pages": [
    {
      "name": "page_event",
      "title": "Event-detaljer",
      "elements": [
        {
          "type": "text",
          "name": "short_description",
          "title": "Kort beskrivelse",
          "description": "Til visning i kalender som titel",
          "isRequired": true
        },
        {
          "type": "comment",
          "name": "description",
          "title": "Beskrivelse",
          "isRequired": true
        },
        {
          "type": "text",
          "name": "copy_start_date",
          "width": "100%",
          "startWithNewLine": true,
          "title": "Dato og tidspunkt",
          "isRequired": true,
          "inputType": "datetime-local",
          "defaultDateTime": "12:00"
        },
        {
          "type": "text",
          "name": "copy_end_time",
          "width": "100%",
          "startWithNewLine": true,
          "title": "Sluttidspunkt",
          "isRequired": true,
          "inputType": "time",
          "defaultValue": "13:00"
        },
        {
          "type": "dropdown",
          "name": "sub_event_location",
          "title": "Lokation (valgfri – bruger skabelonens standard hvis tom)",
          "dataSource": "locations",
          "dataSourceKeyField": "locations_name",
          "dataSourceValueField": "guid",
          "mergeWithStaticChoices": true,
          "onChangeUpdateQuestion": "sub_event_room",
          "choices": [{ "value": "manual", "text": "Manuel" }]
        },
        {
          "type": "dropdown",
          "name": "sub_event_room",
          "visibleIf": "{sub_event_location} notempty and {sub_event_location} <> 'manual'",
          "title": "Lokale",
          "dataSource": "locations_rooms",
          "dataSourceKeyField": "room_name",
          "dataSourceValueField": "guid"
        },
        {
          "type": "text",
          "name": "sub_event_manual_location",
          "visibleIf": "{sub_event_location} = 'manual'",
          "title": "Manuel lokation - Navn",
          "requiredIf": "{sub_event_location} = 'manual'",
          "isRequired": false
        },
        {
          "type": "text",
          "name": "sub_event_manual_location_address",
          "visibleIf": "{sub_event_location} = 'manual'",
          "title": "Manuel lokation - Adresse",
          "requiredIf": "{sub_event_location} = 'manual'",
          "isRequired": false
        },
        {
          "type": "text",
          "name": "sub_event_manual_room_capacity",
          "visibleIf": "{sub_event_location} notempty",
          "title": "Manuel lokale - Antal",
          "description": "Påkrævet hvis intet lokale valgt",
          "requiredIf": "{sub_event_location} notempty and {sub_event_room} empty",
          "inputType": "number"
        },
        {
          "type": "dualpanel",
          "name": "event_modules",
          "title": "Moduler",
          "dataSource": "dual_panel_modules"
        }
      ]
    }
  ],
  "navigationButtonsLocation": "topBottom",
  "showTitle": false,
  "showCompletePage": false,
  "checkErrorsMode": "onValueChanged",
  "showEmptyFormSubmit": false
}
